/**
 * Box Shadow schema
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { BP, ISchemaStringWithConst, ISchemaStringWithConstOpts } from "@adapptio/lib-blueprint";
import { BOX_SHADOW, BOX_SHADOW_default } from "../Enums/BOX_SHADOW";
import { getValuesFromStringEnum } from "../Functions/enumHelpers";

import { termsEditor } from "../terms";

/**
 * Box Shadow schema
 *
 * @param opts Options
 */
export function BoxShadowSchema(
	opts: Partial<ISchemaStringWithConstOpts> = { alias: "boxShadow" }
): ISchemaStringWithConst {
	return BP.StringWithConst({
		...termsEditor.schemas.common.boxShadow,
		constants: getValuesFromStringEnum(BOX_SHADOW, termsEditor.schemas.common.boxShadowValues),
		default: BOX_SHADOW_default,
		fallbackValue: BOX_SHADOW_default,
		...opts
		/*constraints: {
			//...LibComponentsTerms.schemas.common.boxShadowConstraints,
			//pattern: ,
			...opts.constraints
		}*/
	});
}
